import 'alpinejs';

window.dropDownMenu = function () {
  return {
    // wenn > 1023.98px ist show = true sonst false
    // unnötig, da ab 1024 das Menü gar nicht angezeigt wird
    show: !!window.matchMedia('(min-width: 1023.98px)').matches,
    open() {
      this.show = true;
    },
    close() {
      // if (navigator.maxTouchPoints < 5 || navigator.platform !== 'MacIntel') {
      //   if (window.matchMedia('(max-width: 1023.98px)').matches) {
      this.show = false;
      // }
      // }
    },
    isOpen() {
      // if (navigator.maxTouchPoints < 5 || navigator.platform !== 'MacIntel') {
      //   if (window.matchMedia('(max-width: 1023.98px)').matches) {
      return this.show === true;
      // }
      // }
    }
  };
};

// Submenu
const submenuOpenLinks = document.querySelectorAll('#topbar nav ul li.dropdown');
if (submenuOpenLinks) {
  for (const submenuOpenLink of submenuOpenLinks) {
    submenuOpenLink.setAttribute('x-data', '{ open: false }');
  }
}
